import * as yup from 'yup'

export class NeedsToBeTakenToSecretaryOfStateTitleApplicationDeliveryPhotoDto {
  titleApplicationDeliveryPhotoFileName?: string = undefined
  titleApplicationDeliveryPhotoFile?: File = undefined
}

export const needsToBeTakenToSecretaryOfStateTitleApplicationDeliveryPhotoValidationSchema = yup.object().shape({
  titleApplicationDeliveryPhotoFileName: yup.string().nullable()
})
